export const handleKeyboardActivate = (
    event: KeyboardEvent,
    handler: () => void
) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handler();
    }
};
